module.exports = __webpack_public_path__ + "img/cooler.c7ca1ef0.svg";